<template>
  <div id="searchbar">
    <form @submit.prevent="search">
      <input type="text"
        v-model.trim="query"
        class="form-control"
        :placeholder="$t('general.find_laptop')"
        @keyup="search"
        @focus="focus"
        @blur="blur">

      <span v-show="isLoading" class="loading">
        <i class="far fa-spinner-third fa-spin"></i>
      </span>

      <span v-show="!isLoading" class="search-icon">
        <i class="far fa-search"></i>
      </span>
    </form>

    <transition name="fade">
      <div v-if="show" class="autocomplete">
        <router-link
          v-for="(item, index) in matched"
          :key="index"
          :to="`/product/${item.slug}`"
          class="list-item"
          @click.native="reset">
          <div v-html="highlight(item.name)" />
        </router-link>
      </div>
    </transition>
  </div>
</template>

<script>
// import { debounce } from 'lodash-es';

export default {
  name: 'TheSearchBar',

  data() {
    return {
      isLoading: false,
      query: '',
      show: false,
      result: [],
      list: [],
    };
  },

  computed: {
    matched() {
      if (this.query < 3) return [];
      return this.list.filter((item) => this.findSome(item));
    },
  },

  mounted() {
    this.init();
  },

  methods: {
    async init() {
      const list = await this.fetchList();
      this.list = Object.keys(list).map((key) => ({
        slug: key,
        name: list[key],
      }));
    },

    findSome(item) {
      const query = this.query.toLowerCase();
      const name = item.name.toLowerCase();
      const keywords = query.split(' ');
      const patterns = keywords.map((str) => `(?=.*\\b${str})`);
      const expression = patterns.join('');
      const pattern = new RegExp(expression, 'gi');
      return pattern.test(name);
    },

    search() {
      if (this.query.length < 3) return;
      this.show = true;
    },

    // fetch: debounce(async function debounced() {
    //   this.isLoading = true;
    //   this.result = await this.fetchList();
    //   this.isLoading = false;

    //   if (this.result.length) {
    //     this.show = true;
    //   }
    // }, 500),

    fetchList() {
      return this.$mainApi.get('product-autocomplete')
        .then((res) => res.data.data.result);
    },

    blur() {
      setTimeout(() => {
        this.show = false;
      }, 300);
    },

    focus() {
      if (this.matched.length > 0) {
        this.show = true;
      }
    },

    reset() {
      this.query = '';
    },

    highlight(str) {
      const keywords = this.query.split(/\s/);
      const pattern = new RegExp(`(${keywords.join('|')})`, 'gi');
      return str.replace(pattern, (match) => `<strong class="highlight">${match}</strong>`);
    },
  },
};
</script>

<style lang="scss">
  #searchbar {
    position: relative;
    display: flex;
    align-items: center;
    padding: 0 1rem;
    width: 45%;

    @include media ("<=tablet") {
      width: calc(100% - 8rem);
    }

    form {
      width: 100%;
    }

    input {
      width: 100%;
      font-size: 0.875rem;

      @include media ('<=tablet') {
        background-color: transparent;
        border: none;
      }
    }

    .search-icon,
    .loading {
      position: absolute;
      top: 0.375rem;
      right: 2rem;
      height: 1.5rem;
      color: $color-secondary;

      svg {
        height: 1rem;
        width: 1rem;
      }
    }

    .search-icon {
      color: $grey;
    }

    .autocomplete {
      position: absolute;
      top: 100%;
      max-height: 400px;
      width: calc(150% - 2rem);
      background-color: $white;
      border-radius: 0 0 0.25rem 0.25rem;
      box-shadow: 0 0.25rem 1rem -0.25rem rgba($black, 0.8);
      overflow: auto;

      .list-item {
        display: block;
        padding: 0.5rem 1rem  ;
        width: 100%;
        text-overflow: ellipsis;
        border-bottom: 1px solid $grey-fade;
        overflow: hidden;
        white-space: nowrap;
        color: #333;
        font-size: 0.865rem;
        text-decoration: none;

        &:last-child {
          border-bottom: none;
        }

        &:hover {
          background-color: $color-primary;
        }
      }

      .highlight {
        display: inline-block;
        border-bottom: 2px solid $color-primary;
        font-weight: 600;
        font-size: 0.875rem !important;
        line-height: 1em;
      }
    }
  }
</style>
